// extracted by mini-css-extract-plugin
export var Gallery = "Gallery-module--Gallery--7e9c0";
export var GalleryColumn = "Gallery-module--GalleryColumn--cf619";
export var GalleryColumnShort = "Gallery-module--GalleryColumnShort--23999";
export var GalleryGrid = "Gallery-module--GalleryGrid--aaeb4";
export var GalleryMobileList = "Gallery-module--GalleryMobileList--cf0f7";